import { EndOrderDetailPaymentLink, PaymentMethod } from '@pedix-workspace/utils';

export const getActivePaymentMethods = (paymentMethods?: PaymentMethod[]): PaymentMethod[] => {
  if (!Array.isArray(paymentMethods)) {
    return [];
  }

  const activePaymentMethods = paymentMethods.filter(pm => pm.active);

  const paymentMethodsWithLink = activePaymentMethods.filter(pm => pm.hasLink);
  const paymentMethodsWithoutLink = activePaymentMethods.filter(pm => !pm.hasLink);

  const sortedPaymentMethodsWithLink = paymentMethodsWithLink.sort((a, b) => {
    return getPaymentMethodOrder(a.type) - getPaymentMethodOrder(b.type);
  });

  const sortedActivePaymentMethods = [
    ...paymentMethodsWithoutLink,
    ...sortedPaymentMethodsWithLink,
  ];

  return sortedActivePaymentMethods.map(paymentMethod => {
    if (paymentMethod.hasLink) {
      switch (paymentMethod.type) {
        case 'ZENRISE_LINK':
          paymentMethod.name = 'Pago online (T. débito / crédito)';
          break;
        case 'MERCADOPAGO_LINK':
          paymentMethod.name = 'Pago online (T. débito / crédito / Mercadopago)';
          break;
        case 'UALA_LINK':
          paymentMethod.name = 'Pago online (T. débito / crédito / Ualá)';
          break;
      }
    }
    return paymentMethod;
  });
};

export const EMPTY_PAYMENT_LINK: EndOrderDetailPaymentLink = {
  status: 'PENDING',
  updated: new Date(),
};

// NOTE: this utility function is used to reset paymentMethodLink when orderPriceChanged
// Ideally, we shouldn't need to compute this manually; it should be enough by setting the paymentMethodLink to null
// In the future, we might want to refactor how paymentLink functionality works
export const getNextPaymentMethodLink = (
  orderPriceChanged: boolean,
  paymentMethod?: PaymentMethod | null,
): EndOrderDetailPaymentLink | null | undefined => {
  if (orderPriceChanged) {
    return paymentMethod?.hasLink ? EMPTY_PAYMENT_LINK : null;
  }
  // NOTE: undefined value will be ignored on purpose, so previous value on firestore will be preserved
  return undefined;
};

function getPaymentMethodOrder(type: string): number {
  switch (type) {
    case 'ZENRISE_LINK':
      return 1;
    case 'MERCADOPAGO_LINK':
      return 2;
    case 'UALA_LINK':
      return 3;
    default:
      return 4;
  }
}
